import script from "./PhotoCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoCarousel.vue?vue&type=style&index=0&id=ad6eafd8&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad6eafd8"]])

export default __exports__